import { Pipe, PipeTransform } from '@angular/core';
/*
 * Takes a string and format acordinly to format
 * Usage:
 *   cardstring | cardnumberFormat
 * Example:
 *   {{ 12345678900 | cardnumber }}
 *   formats to: ********8900 
*/
@Pipe({name: 'cardnumberFormat'})
export class CardnumberFormatPipe implements PipeTransform {
  transform( cardnumber: string ): string {
    if ( ! cardnumber ) {
      return "Sem número do cartão";
    }

    let lastDigits = cardnumber.substr( -4 );

    return `*********${ lastDigits }`;
  }
}
